export default "__VITE_ASSET__xz$IhvyH__"